module.exports = __webpack_public_path__ + "assets/img/about02.cb556e41.png";